import React from "react";
import ulLogo from "../../assets/images/ultra-librarian-logo.svg";
import System from "src/helper/system";
import Api from "src/service/APIHandler";
import Product from "@system/config/product";

const API = new Api({});
let manufacturerCache = null;

const getManufacturerSlug = async (manufacturerName) => {
  if (!manufacturerCache) {
    try {
      const res = await API.get(Product.MANUFACTURER_ALL);
      manufacturerCache = res?.data?.Data || [];
    } catch (e) {
      manufacturerCache = [];
    }
  }
  const match = manufacturerCache.find(
    (m) => m.manufacturerName?.toLowerCase() === manufacturerName?.toLowerCase()
  );
  if (match?.url) {
    return match.url.split("/").pop();
  }
  return encodeURIComponent(manufacturerName);
};

const UltraLibrarianModal = ({ value }) => {
  const manufacturerName = value?.ManufacturerName;
  // UL prefers the true MPN (secondary) over the Avnet-formatted part number, ERP number as last resort
  const partNumber = value?.AliasPartNumberSecondarySupplier || value?.ManufacturerPartNumber || value?.ERPPartNumber;

  if (!manufacturerName || !partNumber) return null;

  const openModal = async (e) => {
    e.preventDefault();
    const manufacturerSlug = await getManufacturerSlug(manufacturerName);
    System.popup("UltraLibrarianPopup", { manufacturerSlug, partNumber });
  };

  return (
    <div className="cad-link" onClick={openModal}>
      <a href={void 0}>
        <img alt="Ultra Librarian PCB Symbol, Footprint & 3D Model" src={ulLogo} style={{ height: "32px" }} />
      </a>
    </div>
  );
};

export default UltraLibrarianModal;
